enum TaskStatus {
  WAITING,
  IN_PROGRESS,
  ERROR,
  WARNING,
  SUCCESS,
}

export default TaskStatus;
